import styles from './CaseStudyItem.module.scss';

import cx from 'classnames';
import React, { FC } from 'react';

import { TextV2 } from 'components/TextV2/TextV2';
import { FlatEntry } from 'services/cms/flattenContentful';
import { useBreakpoints } from 'hooks/useBreakpoints';
import { Topic } from 'api/contentful/contentTypes.cloverdotcom';
import { isAriaCondition } from 'utils/isAriaCondition';
import { ButtonLinkV2 } from 'components/Button/ButtonLinkV2';
import { SubjectImage } from 'components/SubjectImage/SubjectImage';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';

type CaseStudyItemProps = {
  entry?: FlatEntry<Topic>;
  isActive?: boolean;
  tabIndex?: number;
  renderImage?: boolean;
};

export const CaseStudyItem: FC<CaseStudyItemProps> = ({ entry, isActive, tabIndex, renderImage }) => {
  const { browser } = useBreakpoints();

  if (!entry) return null;

  const { title, blurb, link, richBlurb } = entry;
  const isDesktop = browser.is.desktop;

  return (
    <div className={styles.accordionItem}>
      {renderImage && (
        <div className={styles.mediaWrapper}>
          <SubjectImage className={styles.accordionMedia} entry={entry} />
          <div className={styles.accordionGradient} />
        </div>
      )}
      <div className={styles.contentWrapper}>
        <div className={styles.overlayContainerText}>
          <TextV2
            aria-hidden={isAriaCondition(!isActive)}
            className={styles.overlayTextTitle}
            tagName="h3"
            value={title}
            variant={isDesktop ? 'modern-body-large-medium' : 'modern-body-medium'}
          />
          <TextV2
            aria-hidden={isAriaCondition(!isActive)}
            className={styles.overlayText}
            value={blurb}
            tagName="p"
            variant={isDesktop ? 'modern-body-large-medium' : 'modern-body-medium'}
          />
          <RichBlurb
            aria-hidden={isAriaCondition(!isActive)}
            className={styles.overlayText}
            document={richBlurb}
            noParagraph
            tagName="p"
            textVariant={isDesktop ? 'modern-body-large-medium' : 'modern-body-medium'}
          />
        </div>
        {link && (
          <ButtonLinkV2
            className={cx(styles.footerExpandedItemLink, !isActive && styles.footerExpandedItemLinkInactive)}
            entry={link}
            isButton
            size="small"
            tabIndex={tabIndex}
          ></ButtonLinkV2>
        )}
      </div>
    </div>
  );
};
